import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavSteps } from '../../hooks/useSyncFlowNav';

const CalSyncDialogStrings = {
  failureToast: (
    <FormattedMessage
      id="calendar.sync_flow.toast.sync_error"
      defaultMessage="Calendar sync failed. Please try again"
    />
  ),
  noCalsToSyncToast: (
    <FormattedMessage
      id="calendar.sync_flow.toast.no_cals_to_sync"
      defaultMessage="Uh oh! We couldn't find any calendars to sync with.
      Please make sure you have at least one calendar on the account you're trying to sync with."
    />
  ),
  successToast: (
    <FormattedMessage
      id="calendar.sync_flow.toast.sync_success"
      defaultMessage="Calendar sync successfully set up"
    />
  ),
  getStartedButton: (
    <FormattedMessage
      id="calendar.sync_flow.button_get_started"
      defaultMessage="Get started"
    />
  ),
  continueButton: (
    <FormattedMessage
      id="calendar.sync_flow.dialog.button_continue"
      defaultMessage="Continue"
    />
  )
};

export const TitleStepMap = {
  [NavSteps.VALUE_PROPS]: <FormattedMessage id="calendar.sync_flow.dialog.title_sync_calendar" defaultMessage="Sync calendar" />,
  [NavSteps.EXTERNAL_CAL_SELECTION]: <FormattedMessage id="calendar.sync_flow.dialog.title_add_external_cal" defaultMessage="Add external calendar" />,
  [NavSteps.SELECT_CALENDAR]: <FormattedMessage id="calendar.sync_flow.dialog.title_select_cal_to_sync" defaultMessage="Select calendar to sync"/>,
  [NavSteps.I_CALENDAR]: <FormattedMessage id="calendar.sync_flow.dialog.title_import_cal" defaultMessage="Import calendar" />
};

export default CalSyncDialogStrings;
